module.exports = __webpack_public_path__ + "img/MasterCard.ec6d71d5.svg";